import { SegmentationData } from '~/backend/segmentationMetrics';
import { csvEscapeCell } from '~/utils/io/files/handleFileExport';
import { SegmetricsColumn } from './segmetricsColumns';

/**
 * Builds an RFC 4180 CSV (CRLF line endings) from segmetrics results.
 * Missing metrics (null from a column's format) are emitted as empty
 * cells rather than the on-screen placeholder so the file stays
 * machine-readable.
 *
 * @param data - segmetrics results, one row per structure
 * @param columns - columns to include, in output order
 * @param getHeader - resolves a column to its header text
 */
export function buildSegmetricsCsv(
    data: SegmentationData[],
    columns: SegmetricsColumn[],
    getHeader: (column: SegmetricsColumn) => string
): string {
    const headers = columns.map(getHeader);
    const rows = data.map((item) =>
        columns.map((column) => column.format(item) ?? '')
    );
    return [headers, ...rows]
        .map((row) => row.map(csvEscapeCell).join(','))
        .join('\r\n');
}
